if (!customElements.get('rf-category-menu')) {
  customElements.define('rf-category-menu', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const buttons = [...this.querySelectorAll('[data-rf-category]')];
      const panels = [...this.querySelectorAll('[data-rf-panel]')];
      const activate = (button) => {
        buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
        panels.forEach(panel => { panel.hidden = panel.dataset.rfPanel !== button.dataset.rfCategory; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') activate(button);
        }, { signal });
        button.addEventListener('focus', () => activate(button), { signal });
        button.addEventListener('click', () => activate(button), { signal });
        button.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
          event.preventDefault();
          buttons[(index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length].focus();
        }, { signal });
      });
      if (buttons.length) activate(buttons[0]);
      this.dataset.ready = 'true';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
